import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "bg-white shadow-sm" }
const _hoisted_3 = { class: "max-w-6xl mx-auto px-4 py-3 flex items-center justify-between" }
const _hoisted_4 = {
  href: "/",
  class: "text-xl font-bold text-blue-700"
}
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = {
  href: "/",
  class: "text-sm text-gray-600 hover:text-blue-700"
}
const _hoisted_7 = { class: "text-sm text-gray-500" }
const _hoisted_8 = {
  href: "/users/sign_out",
  "data-turbo-method": "delete",
  class: "text-sm text-red-600 hover:text-red-800"
}
const _hoisted_9 = { class: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_10 = { class: "flex items-center justify-between mb-8" }
const _hoisted_11 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_12 = { class: "flex items-center gap-4" }
const _hoisted_13 = { class: "text-sm text-gray-500" }
const _hoisted_14 = { class: "mb-6" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "bg-white shadow rounded-lg overflow-hidden" }
const _hoisted_17 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_18 = { class: "bg-gray-50" }
const _hoisted_19 = { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }
const _hoisted_20 = { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }
const _hoisted_21 = { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }
const _hoisted_22 = { class: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" }
const _hoisted_23 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_25 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_26 = { class: "px-6 py-4 whitespace-nowrap text-sm" }
const _hoisted_27 = {
  key: 0,
  class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
}
const _hoisted_28 = {
  key: 1,
  class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
}
const _hoisted_29 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_30 = { class: "px-6 py-4 whitespace-nowrap text-right text-sm space-x-2" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  colspan: "5",
  class: "px-6 py-8 text-center text-sm text-gray-500"
}
const _hoisted_35 = { class: "mt-6" }
const _hoisted_36 = {
  href: "/",
  class: "text-blue-700 hover:text-blue-900 text-sm font-medium"
}
const _hoisted_37 = { class: "bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6" }
const _hoisted_38 = { class: "text-lg font-bold text-gray-900 mb-6" }
const _hoisted_39 = {
  key: 0,
  class: "mb-4 bg-red-50 border border-red-200 rounded-lg px-4 py-3"
}
const _hoisted_40 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_41 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_42 = {
  key: 0,
  class: "text-gray-400 font-normal"
}
const _hoisted_43 = ["required"]
const _hoisted_44 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_45 = ["required"]
const _hoisted_46 = { class: "flex items-center gap-2" }
const _hoisted_47 = { class: "flex justify-end gap-3 pt-4" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "bg-white rounded-xl shadow-xl w-full max-w-sm mx-4 p-6" }
const _hoisted_50 = { class: "text-lg font-bold text-gray-900 mb-2" }
const _hoisted_51 = { class: "text-sm text-gray-600 mb-6" }
const _hoisted_52 = {
  key: 0,
  class: "mb-4 bg-red-50 border border-red-200 rounded-lg px-4 py-3"
}
const _hoisted_53 = { class: "text-sm text-red-700" }
const _hoisted_54 = { class: "flex justify-end gap-3" }
const _hoisted_55 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Navbar "),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, _toDisplayString($setup.t('site_name')), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", _hoisted_6, _toDisplayString($setup.t('nav.home')), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_7, _toDisplayString($props.userEmail), 1 /* TEXT */),
          _createElementVNode("a", _hoisted_8, _toDisplayString($setup.t('auth.sign_out')), 1 /* TEXT */)
        ])
      ])
    ]),
    _createCommentVNode(" Admin Users "),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h1", _hoisted_11, _toDisplayString($setup.t('admin.users.title')), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString($setup.t('admin.users.total', { count: $setup.userList.length })), 1 /* TEXT */),
          _createElementVNode("button", {
            onClick: $setup.openCreateModal,
            class: "bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-800 transition"
          }, _toDisplayString($setup.t('admin.users.add_user')), 1 /* TEXT */)
        ])
      ]),
      _createCommentVNode(" Flash message "),
      ($setup.flash)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['mb-4 px-4 py-3 rounded-lg text-sm', $setup.flash.type === 'success' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'])
          }, _toDisplayString($setup.flash.message), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Search "),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.search) = $event)),
          type: "text",
          placeholder: $setup.t('admin.users.search'),
          class: "w-full max-w-md px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
        }, null, 8 /* PROPS */, _hoisted_15), [
          [_vModelText, $setup.search]
        ])
      ]),
      _createCommentVNode(" Table "),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("table", _hoisted_17, [
          _createElementVNode("thead", _hoisted_18, [
            _createElementVNode("tr", null, [
              _cache[5] || (_cache[5] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "ID", -1 /* CACHED */)),
              _createElementVNode("th", _hoisted_19, _toDisplayString($setup.t('admin.users.email')), 1 /* TEXT */),
              _createElementVNode("th", _hoisted_20, _toDisplayString($setup.t('admin.users.role')), 1 /* TEXT */),
              _createElementVNode("th", _hoisted_21, _toDisplayString($setup.t('admin.users.created_at')), 1 /* TEXT */),
              _createElementVNode("th", _hoisted_22, _toDisplayString($setup.t('admin.users.actions')), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredUsers, (user) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: user.id,
                class: "hover:bg-gray-50 transition"
              }, [
                _createElementVNode("td", _hoisted_24, _toDisplayString(user.id), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_25, _toDisplayString(user.email), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_26, [
                  (user.admin)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, " Admin "))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, " User "))
                ]),
                _createElementVNode("td", _hoisted_29, _toDisplayString($setup.formatDate(user.created_at)), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_30, [
                  _createElementVNode("button", {
                    onClick: $event => ($setup.openEditModal(user)),
                    class: "text-blue-600 hover:text-blue-800 font-medium"
                  }, _toDisplayString($setup.t('admin.users.edit')), 9 /* TEXT, PROPS */, _hoisted_31),
                  _createElementVNode("button", {
                    onClick: $event => ($setup.confirmDelete(user)),
                    class: "text-red-600 hover:text-red-800 font-medium"
                  }, _toDisplayString($setup.t('admin.users.delete')), 9 /* TEXT, PROPS */, _hoisted_32)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            ($setup.filteredUsers.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                  _createElementVNode("td", _hoisted_34, _toDisplayString($setup.t('admin.users.no_results')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("a", _hoisted_36, _toDisplayString($setup.t('admin.users.back_to_home')), 1 /* TEXT */)
      ])
    ]),
    _createCommentVNode(" Create/Edit Modal "),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("h2", _hoisted_38, _toDisplayString($setup.editing ? $setup.t('admin.users.edit_user') : $setup.t('admin.users.new_user')), 1 /* TEXT */),
            ($setup.formErrors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formErrors, (error) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: error,
                      class: "text-sm text-red-700"
                    }, _toDisplayString(error), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("form", {
              onSubmit: _withModifiers($setup.submitForm, ["prevent"]),
              class: "space-y-4"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_40, _toDisplayString($setup.t('admin.users.email')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.form.email) = $event)),
                  type: "email",
                  required: "",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.email]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_41, [
                  _createTextVNode(_toDisplayString($setup.t('auth.password')) + " ", 1 /* TEXT */),
                  ($setup.editing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString($setup.t('admin.users.password_hint')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.form.password) = $event)),
                  type: "password",
                  required: !$setup.editing,
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                }, null, 8 /* PROPS */, _hoisted_43), [
                  [_vModelText, $setup.form.password]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_44, _toDisplayString($setup.t('auth.password_confirmation')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.form.password_confirmation) = $event)),
                  type: "password",
                  required: !$setup.editing,
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                }, null, 8 /* PROPS */, _hoisted_45), [
                  [_vModelText, $setup.form.password_confirmation]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.form.admin) = $event)),
                  type: "checkbox",
                  id: "admin-checkbox",
                  class: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.form.admin]
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("label", {
                  for: "admin-checkbox",
                  class: "text-sm font-medium text-gray-700"
                }, "Admin", -1 /* CACHED */))
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: $setup.closeModal,
                  class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
                }, _toDisplayString($setup.t('admin.users.cancel')), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: $setup.submitting,
                  class: "px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50"
                }, _toDisplayString($setup.submitting ? '...' : ($setup.editing ? $setup.t('admin.users.save') : $setup.t('admin.users.create'))), 9 /* TEXT, PROPS */, _hoisted_48)
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Delete Confirmation Modal "),
    ($setup.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeDeleteModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("h2", _hoisted_50, _toDisplayString($setup.t('admin.users.confirm_delete')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_51, _toDisplayString($setup.t('admin.users.confirm_delete_message', { email: $setup.deleteTarget?.email })), 1 /* TEXT */),
            ($setup.deleteError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("p", _hoisted_53, _toDisplayString($setup.deleteError), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("button", {
                onClick: $setup.closeDeleteModal,
                class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
              }, _toDisplayString($setup.t('admin.users.cancel')), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: $setup.deleteUser,
                disabled: $setup.submitting,
                class: "px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition disabled:opacity-50"
              }, _toDisplayString($setup.submitting ? '...' : $setup.t('admin.users.delete')), 9 /* TEXT, PROPS */, _hoisted_55)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}